import React, { useState } from "react";
import Modal from "components/modal";
import { Select } from "components/form-inputs/inputs/select";
import { putTaskAssignment } from "components/task-list/lib/taskData";
import { setProfilingGroup } from "admin/assignment/lib/data";
import { error, success } from "shared/notify";
import { DEFAULT_GENERIC_ERROR } from "shared/constants";

const AssignmentCell = (props) => {
    const [showModal, setShowModal] = useState(false);

    const originalRow = props.row && props.row.original;
    const taskKey = originalRow && originalRow.key;
    const assignmentGroupKey = props.isProfiling ? originalRow.profilingTasksAssignmentGroupKey : originalRow.assignmentGroupKey;
    const isProfilingNotCompleted = props.isProfiling && !originalRow.isSchedulingCompleted;

    const successCallback = (res) => {
        if (props.isProfiling) {
            originalRow.profilingTasksAssignmentGroupKey = res.groupKey;
        } else {
            originalRow.assignmentGroupKey = res.groupKey;
        }

        setShowModal(false);
    };

    const handleCloseModal = () => {
        setDropdownChoice(assignmentGroupKey || "");
        setShowModal(false);
    };

    const [dropdownChoice, setDropdownChoice] = useState(assignmentGroupKey || "");

    const display =
        isProfilingNotCompleted || (!props.isProfiling && !originalRow.isCompleted) ? (
            <a
                href="/task-list/imageediting#"
                onClick={handleLinkClick(setShowModal)}
            >
                {getGroupNameFromKey(assignmentGroupKey, props.options) || "Available"}
            </a>
        ) : (
            <span>{getGroupNameFromKey(assignmentGroupKey, props.options) || "Available"}</span>
        );

    return (
        <div onDoubleClick={stopDoubleClick}>
            {display}
            <Modal
                show={showModal}
                onClose={handleCloseModal}
                cssClass="team-assignment-modal"
            >
                <h2>Assign a team to this task</h2>
                <div className="form-field flex-column">
                    <label htmlFor="assignment-selector">Teams:</label>
                    <Select
                        id="assignment-selector"
                        onChange={(event) => setDropdownChoice(event.target.value)}
                        style={{ width: "100%" }}
                        value={dropdownChoice}
                        options={[{ text: "Available", value: "" }, ...props.options]}
                        excludeSelect={true}
                    />
                </div>
                <p className="flex font-sm">User Assignment will be set to ‘available’ if they are not part of the updated team assignment.</p>
                <div className="button-group -right">
                    <button
                        className="button"
                        onClick={handleCloseModal}
                    >
                        Cancel
                    </button>
                    <button
                        className="button -primary"
                        onClick={handleSaveClick(taskKey, dropdownChoice, successCallback, props.isProfiling, props.assignedUser)}
                    >
                        Assign
                    </button>
                </div>
            </Modal>
        </div>
    );
};

const getGroupNameFromKey = (key, groupList) => {
    const result = groupList.find((li) => li.value === key);

    return result && result.text;
};

const stopDoubleClick = (e) => {
    e.stopPropagation();
};

const handleSaveClick = (taskKey, groupKey, successCallback, isProfiling, assignedUser) => async (e) => {
    e.preventDefault();

    if (isProfiling) {
        const res = await setProfilingGroup("scheduling", groupKey, [taskKey], assignedUser);

        if (res.taskKey) {
            success("Assignment saved");
            successCallback(res);
        } else {
            error(DEFAULT_GENERIC_ERROR);
        }
    } else {
        const res = await putTaskAssignment(taskKey, groupKey);

        if (res.taskKey) {
            success("Assignment saved");
            successCallback(res);
        } else {
            error(DEFAULT_GENERIC_ERROR);
        }
    }
};

const handleLinkClick = (setShowModal) => (e) => {
    e.preventDefault();

    setShowModal(true);
};

export default AssignmentCell;
